<script>
  // A boolean filter. Renders like every other filter control: label ABOVE the
  // control (via FilterField), checkbox on the shared h-8 control row.
  // `plain` renders the checkbox with its text beside it instead, for checkboxes
  // composed inside an already-labeled FilterField group (e.g. a "Schedule"
  // group of two checkboxes).
  //   <FilterCheckbox label="Active only" checked={filters.active_only} onchange={(v) => …} />
  import FilterField from './filter_field.svelte'
  let { label, checked = false, disabled = false, title = undefined, plain = false, onchange = null } = $props()
</script>

{#if plain}
  <label class="flex items-center gap-2 text-sm select-none h-8" class:cursor-pointer={!disabled} class:opacity-50={disabled} class:cursor-not-allowed={disabled} {title}>
    <!-- rounded-sm: the theme's --radius-selector makes checkbox-sm look like a radio -->
    <input type="checkbox" class="checkbox checkbox-sm rounded-sm" {checked} {disabled} onchange={(e) => onchange?.(e.currentTarget.checked)} />
    {label}
  </label>
{:else}
  <FilterField {label}>
    <label class="flex items-center h-8 select-none" class:cursor-pointer={!disabled} class:opacity-50={disabled} class:cursor-not-allowed={disabled} {title}>
      <!-- rounded-sm: the theme's --radius-selector makes checkbox-sm look like a radio -->
      <input
        type="checkbox"
        class="checkbox checkbox-sm rounded-sm"
        {checked}
        {disabled}
        aria-label={label}
        onchange={(e) => onchange?.(e.currentTarget.checked)}
      />
    </label>
  </FilterField>
{/if}
